import React, { useState } from "react";
import {
  MapPinIcon,
  UserIcon,
  PhoneIcon,
  EnvelopeIcon,
} from "@heroicons/react/24/outline";
// import axios from "axios";
import axios from "../../../context/axios";
import { useNavigate } from "react-router-dom";

const Spinner = () => (
  <svg
    className="animate-spin h-5 w-5 text-white mx-auto"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    ></circle>
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
    ></path>
  </svg>
);

const EnquiryModal = ({ isOpen, onClose, tour, userId }) => {
  const [formErrors, setFormErrors] = useState({});

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    guests: { adult: 0, child: 0, infant: 0 },
    specialRequest: "",
  });

  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleGuestChange = (type, delta) => {
    setFormData((prev) => ({
      ...prev,
      guests: {
        ...prev.guests,
        [type]: Math.max(0, prev.guests[type] + delta),
      },
    }));
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Live validation
    setFormErrors((prevErrors) => {
      const errors = { ...prevErrors };

      if (name === "phone") {
        if (!/^\d{10}$/.test(value.trim())) {
          errors.phone = "Mobile number must be exactly 10 digits.";
        } else {
          delete errors.phone;
        }
      }

      if (name === "email") {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())) {
          errors.email = "Please enter a valid email address.";
        } else {
          delete errors.email;
        }
      }

      return errors;
    });
  };
  const isFormValid =
    formData.firstName.trim() &&
    formData.lastName.trim() &&
    /^\d{10}$/.test(formData.phone.trim()) && // must be exactly 10 digits
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim()) && // valid email format
    (formData.guests.adult > 0 ||
      formData.guests.child > 0 ||
      formData.guests.infant > 0);
  const handleSubmit = async () => {
    if (
      !formData.firstName.trim() ||
      !formData.lastName.trim() ||
      !formData.phone.trim() ||
      !formData.email.trim()
    ) {
      alert("Please fill all required fields.");
      return;
    }

    setSubmitting(true);
    try {
      const user = JSON.parse(localStorage.getItem("user"));

      const userId = user ? user._id : null;

      const payload = {
        tourId: tour?._id,
        fullName: `${formData.firstName} ${formData.lastName}`.trim(),
        phone: formData.phone,
        email: formData.email,
        guests: formData.guests,
        specialRequest: formData.specialRequest,
        date: new Date().toISOString(),
      };

      // Add userId only if it exists
      if (userId) {
        payload.userId = userId;
      }

      const res = await axios.post("/tours/tourReservations", payload);

      // Show confirmation page instead of alert & onClose
      navigate("/enquiry-confirmation", {
        state: { tour, fullName: payload.fullName },
      });
    } catch (err) {
      console.error(err);
      alert("Something went wrong. Please try again.");
    }
    setSubmitting(false);
  };

  return (
    <div className="fixed inset-0 z-50 flex justify-center items-start pt-20 bg-black bg-opacity-50 overflow-y-auto">
      <div className="bg-white rounded-md shadow-lg w-full max-w-xl mx-4 p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 text-xl font-bold"
        >
          &times;
        </button>

        <h2 className="text-lg font-bold mb-4 text-center">
          Want to Go For A Memorable Holiday?
        </h2>

        {/* Package Name Field with Map Icon */}
        <label className="block text-sm font-medium mb-1">Package Name</label>
        <div className="relative">
          <input
            type="text"
            value={tour?.title || ""}
            disabled
            className="w-full border rounded px-3 py-2 text-sm mb-4 bg-gray-100 pr-10"
          />
          <MapPinIcon className="h-5 w-5 text-gray-500 absolute right-3 top-2.5" />
        </div>

        <div className="grid md:grid-cols-2 gap-4 mb-4">
          {/* Full Name */}
          <div>
            <div className="grid grid-cols-2 gap-2">
              <div>
                <label className="block text-sm font-medium mb-1">
                  First Name
                </label>
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  value={formData.firstName}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2 text-sm pr-10"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">
                  Last Name
                </label>
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  value={formData.lastName}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2 text-sm pr-10"
                />
              </div>
            </div>
          </div>

          {/* Mobile Number */}
          <div>
            {/* <label className="block text-sm font-medium mb-1">Mobile No.</label>
            <div className="flex border rounded relative">
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Mobile No."
                className="w-full px-3 py-2 text-sm pr-10"
              />
              <PhoneIcon className="h-5 w-5 text-gray-500 absolute right-3 top-2.5" />
            </div> */}
            <label className="block text-sm font-medium mb-1">Mobile No.</label>
            <div className="flex border rounded relative">
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Mobile No."
                className="w-full px-3 py-2 text-sm pr-10"
              />
              <PhoneIcon className="h-5 w-5 text-gray-500 absolute right-3 top-2.5" />
            </div>
            {formErrors.phone && (
              <p className="text-red-500 text-xs mt-1">{formErrors.phone}</p>
            )}
          </div>
        </div>

        {/* Email */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Email ID</label>
          <div className="relative">
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Your E-Mail Address"
              className="w-full border rounded px-3 py-2 text-sm pr-10"
            />
            <EnvelopeIcon className="h-5 w-5 text-gray-500 absolute right-3 top-2.5" />
          </div>
        </div>

        {/* Guest Count */}
        <div className="grid grid-cols-3 gap-4 text-center mb-4">
          {["adult", "child", "infant"].map((type, i) => (
            <div key={i}>
              <label className="block text-sm font-medium capitalize mb-1">
                {type}
              </label>
              <div className="flex items-center justify-center gap-2 border rounded px-2 py-1">
                <button
                  type="button"
                  onClick={() => handleGuestChange(type, -1)}
                  className="text-xl font-bold"
                >
                  -
                </button>
                <span>{formData.guests[type]}</span>
                <button
                  type="button"
                  onClick={() => handleGuestChange(type, 1)}
                  className="text-xl font-bold"
                >
                  +
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Special Request */}
        <div className="mb-6">
          <label className="block text-sm font-medium mb-1">
            Special Request
          </label>
          <textarea
            name="specialRequest"
            value={formData.specialRequest}
            onChange={handleChange}
            rows={2}
            placeholder="Any special requests?"
            className="w-full border rounded px-3 py-2 text-sm"
          />
        </div>

        {/* Submit */}
        {/* <button
          onClick={handleSubmit}
          disabled={submitting}
          className="w-full bg-blue-600 text-white rounded-full py-2 md:py-3 text-sm font-semibold hover:bg-blue-700 transition flex justify-center items-center gap-2"
        >
          {submitting ? <Spinner /> : "Enquire Now"}
        </button> */}
        <button
          onClick={handleSubmit}
          disabled={submitting || !isFormValid}
          className={`w-full ${
            submitting || !isFormValid
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-blue-600 hover:bg-blue-700"
          } text-white rounded-full py-2 md:py-3 text-sm font-semibold transition flex justify-center items-center gap-2`}
        >
          {submitting ? <Spinner /> : "Enquire Now"}
        </button>
      </div>
    </div>
  );
};

export default EnquiryModal;

// import React, { useState } from "react";
// import {
//   MapPinIcon,
//   UserIcon,
//   PhoneIcon,
//   EnvelopeIcon,
// } from "@heroicons/react/24/outline";
// import axios from "axios";

// const EnquiryModal = ({ isOpen, onClose, tour, userId }) => {
//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     phone: "",
//     email: "",
//     guests: { adult: 0, child: 0, infant: 0 },
//     specialRequest: "",
//   });

//   const [submitting, setSubmitting] = useState(false);

//   if (!isOpen) return null;

//   const handleGuestChange = (type, delta) => {
//     setFormData((prev) => ({
//       ...prev,
//       guests: {
//         ...prev.guests,
//         [type]: Math.max(0, prev.guests[type] + delta),
//       },
//     }));
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async () => {
//     if (
//       !formData.firstName.trim() ||
//       !formData.lastName.trim() ||
//       !formData.phone.trim() ||
//       !formData.email.trim()
//     ) {
//       alert("Please fill all required fields.");
//       return;
//     }

//     setSubmitting(true);
//     try {
//       const user = JSON.parse(localStorage.getItem("user"));

//       // Extract the userId (_id)
//       const userId = user ? user._id : null;

//       const payload = {
//         userId, // passed from parent
//         tourId: tour?._id,
//         fullName: `${formData.firstName} ${formData.lastName}`.trim(),
//         phone: formData.phone,
//         email: formData.email,
//         guests: formData.guests,
//         specialRequest: formData.specialRequest,
//         date: new Date().toISOString(),
//       };

//       const res = await axios.post("/tours/tourReservations", payload);
//       alert(res.data.message || "Enquiry submitted successfully!");
//       onClose();
//     } catch (err) {
//       console.error(err);
//       alert("Something went wrong. Please try again.");
//     }
//     setSubmitting(false);
//   };

//   return (
//     <div className="fixed inset-0 z-50 flex justify-center items-start pt-20 bg-black bg-opacity-50 overflow-y-auto">
//       <div className="bg-white rounded-md shadow-lg w-full max-w-xl mx-4 p-6 relative">
//         <button
//           onClick={onClose}
//           className="absolute top-3 right-3 text-gray-500 text-xl font-bold"
//         >
//           &times;
//         </button>

//         <h2 className="text-lg font-bold mb-4 text-center">
//           Want to Go For A Memorable Holiday?
//         </h2>

//         {/* Package Name Field with Map Icon */}
//         <label className="block text-sm font-medium mb-1">Package Name</label>
//         <div className="relative">
//           <input
//             type="text"
//             value={tour?.title || ""}
//             disabled
//             className="w-full border rounded px-3 py-2 text-sm mb-4 bg-gray-100 pr-10"
//           />
//           <MapPinIcon className="h-5 w-5 text-gray-500 absolute right-3 top-2.5" />
//         </div>

//         <div className="grid md:grid-cols-2 gap-4 mb-4">
//           {/* Full Name */}
//           <div>
//             <div className="grid grid-cols-2 gap-2">
//               <div>
//                 <label className="block text-sm font-medium mb-1">
//                   First Name
//                 </label>
//                 <input
//                   type="text"
//                   name="firstName"
//                   placeholder="First Name"
//                   value={formData.firstName}
//                   onChange={handleChange}
//                   className="w-full border rounded px-3 py-2 text-sm pr-10"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium mb-1">
//                   Last Name
//                 </label>
//                 <input
//                   type="text"
//                   name="lastName"
//                   placeholder="Last Name"
//                   value={formData.lastName}
//                   onChange={handleChange}
//                   className="w-full border rounded px-3 py-2 text-sm pr-10"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Mobile Number */}
//           <div>
//             <label className="block text-sm font-medium mb-1">Mobile No.</label>
//             <div className="flex border rounded relative">
//               <span className="px-3 py-2 text-sm text-gray-700 bg-gray-100 border-r">
//                 +91
//               </span>
//               <input
//                 type="text"
//                 name="phone"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 placeholder="Mobile No."
//                 className="w-full px-3 py-2 text-sm pr-10"
//               />
//               <PhoneIcon className="h-5 w-5 text-gray-500 absolute right-3 top-2.5" />
//             </div>
//           </div>
//         </div>

//         {/* Email */}
//         <div className="mb-4">
//           <label className="block text-sm font-medium mb-1">Email ID</label>
//           <div className="relative">
//             <input
//               type="email"
//               name="email"
//               value={formData.email}
//               onChange={handleChange}
//               placeholder="Your E-Mail Address"
//               className="w-full border rounded px-3 py-2 text-sm pr-10"
//             />
//             <EnvelopeIcon className="h-5 w-5 text-gray-500 absolute right-3 top-2.5" />
//           </div>
//         </div>

//         {/* Guest Count */}
//         <div className="grid grid-cols-3 gap-4 text-center mb-4">
//           {["adult", "child", "infant"].map((type, i) => (
//             <div key={i}>
//               <label className="block text-sm font-medium capitalize mb-1">
//                 {type}
//               </label>
//               <div className="flex items-center justify-center gap-2 border rounded px-2 py-1">
//                 <button
//                   type="button"
//                   onClick={() => handleGuestChange(type, -1)}
//                   className="text-xl font-bold"
//                 >
//                   -
//                 </button>
//                 <span>{formData.guests[type]}</span>
//                 <button
//                   type="button"
//                   onClick={() => handleGuestChange(type, 1)}
//                   className="text-xl font-bold"
//                 >
//                   +
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Special Request */}
//         <div className="mb-6">
//           <label className="block text-sm font-medium mb-1">
//             Special Request
//           </label>
//           <textarea
//             name="specialRequest"
//             value={formData.specialRequest}
//             onChange={handleChange}
//             rows={2}
//             placeholder="Any special requests?"
//             className="w-full border rounded px-3 py-2 text-sm"
//           />
//         </div>

//         {/* Submit */}
//         <button
//           onClick={handleSubmit}
//           disabled={submitting}
//           className="w-full bg-blue-600 text-white rounded-full py-2 md:py-3 text-sm font-semibold hover:bg-blue-700 transition"
//         >
//           {submitting ? "Submitting..." : "Enquire Now"}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default EnquiryModal;
